import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from "prop-types";
import IterateAndGenerateAlbumDom from './iterate_and_generate_album_dom';
import IterateAndGenerateCaptionSortAlbumDom from './iterate_and_generate_caption_sort_album_dom';
import {fetchCaptionSortAlbumList, fetchOwnedAlbumList, albumsDataReset, getPageClustersList} from '../meta/slices';
import {selectionwedAlbumsData, currentPageNo, captionSortAlbumsData, timeZoneOffset, clustersPerPage, pagesToLoad, captionSortMinimumLimit } from '../meta/selectors';
import { useInView } from 'react-intersection-observer';
import { trigger } from "../../../utils/events";

/* global photoOrg */
const OwnedAlbumsComponent = ({accessType}) => {
try{
    const dispatch = useDispatch();
    
    const currentPage = useRef(0);
    const isJumptoMonth = useRef(false);
    const currentPageLabel = useRef();
    const selectionwedAlbumsResHolder = useRef();

    const [showBottomLoadingBar, setShowBottomLoadingBar] = useState(true);
    const [showTopLoadingBar, setShowTopLoadingBar] = useState(false);
    
   
    const [ref, inView] =  useInView({
         //Optional options */
        threshold: 0.5,
    });
    const [tpref, tpInView] =  useInView({
        //Optional options */
       threshold: 0.5,
   });
    const selectionwedAlbumsRes = useSelector(selectionwedAlbumsData);
    const currentPageno = useSelector(currentPageNo);
    const captionSortAlbumsRes = useSelector(captionSortAlbumsData);
    console.log("selectionwedAlbumsRes=",selectionwedAlbumsRes)
    console.log("captionSortAlbumsRes=",captionSortAlbumsRes);
    
    const jumpToMonthHandler =  useCallback(({ detail }) => {
        let pageNo = parseInt(detail.pageNo);
        let albumId = detail.albumId
        let response = detail.response
        console.log("jumpToMonth=",detail);
        let pagesInBetween = Math.abs(pageNo - currentPage.current)
        currentPageLabel.current = detail.date;

        try{//only scroll without dispatch

            const sortCriteria = photoOrg.history.historyState.sc;
            let element=null;
            if(sortCriteria != "caption"){
                element = document.getElementById(photoOrg.photoLib.getKeyFromDate(currentPageLabel.current));
            }else if(sortCriteria == "caption" && albumId){
                const albumElement = document.getElementById(parseInt(albumId));
                    if (albumElement) {
                        albumElement.scrollIntoView();
                    }
            }else{
                currentPageLabel.current = detail.pageNo;
                element = document.getElementById(detail.pageNo);
            }
            //scroll to date selected by user using the currentPageLabel
            if(currentPageLabel.current && element){
                currentPage.current = pageNo;
                currentPageLabel.current="";
                photoOrg.tracker.add(photoOrg.tracker.constants.ALBUMS_SCRLTO_MONTH,["page:"+pageNo]);
                element.scrollIntoView();//{ behavior: 'smooth', block: 'start' }
                if (albumId) {
                    const albumElement = document.getElementById(parseInt(albumId));
                    if (albumElement) {
                        albumElement.scrollIntoView();
                    }
                }
                return; //setShowTopLoadingBar(true);
            }
            // If albumId is provided, scroll to the specific album within the date cluster
        }catch(e){
            console.log("issue finding the element to scroll")
        }
        isJumptoMonth.current=true;
        if(albumId){
            const albumElement = document.getElementById(parseInt(albumId));
            let pageData = response.pages[pageNo]
                    if (albumElement) {
                        albumElement.scrollIntoView();
                    }else{
                        dispatch(getPageClustersList({
                            url: pageData.currentUrl,
                            currentPage: pageNo,
                            isJumptoMonth: true,
                            append: true,
                            pageNo: pageNo
                        }))
                    }
        }
        if(currentPage.current > pageNo || pagesInBetween > pagesToLoad) {
            currentPage.current = pageNo;
            const pageData = selectionwedAlbumsResHolder.current.pages[currentPage.current];
            console.log("**pageData.currentUrl=",pageData.currentUrl);
            //remove the dom and fresh display of albums
            dispatch(getPageClustersList({
                url: pageData.currentUrl,
                isJumptoMonth: true,
                append: false,
                pageNo: currentPage.current
            }))
        }
        // loading all the pages if the difference between selected and present pages is less than or equal to the configured limit
        else if(currentPage.current < pageNo && pagesInBetween <= pagesToLoad) {
                for (let i=currentPage.current;i<pageNo;i++) {
                     (async () => {
                        currentPage.current = (i+1);
                        const pageData = selectionwedAlbumsResHolder.current.pages[currentPage.current];
                        console.log("^^pageData.currentUrl=",pageData.currentUrl)
                        //to ensure calls trigger in sequence
                        await dispatch(getPageClustersList({
                            url: pageData.currentUrl,
                            currentPage: currentPage.current,
                            isJumptoMonth: true,
                            append: true,
                            pageNo: currentPage.current
                        }))
                    })();
                }
        }
    },[]);
    useEffect(()=>{
        return () => {
            console.log("resetting the state");
            currentPage.current = 0;
            isJumptoMonth.current = false;
            currentPageLabel.current = "";
            selectionwedAlbumsResHolder.current = "";
            document.removeEventListener("rjumpToAlbumsMonth",jumpToMonthHandler);
            dispatch(albumsDataReset())
        }
    },[])

    //selectionwedAlbumsRes(useSelector) value is not accessbile in custom event and cleanup function
    useEffect(() => { 
        selectionwedAlbumsResHolder.current = selectionwedAlbumsRes;
    }, [selectionwedAlbumsRes]);

    useEffect(()=>{
      
        document.removeEventListener("rjumpToAlbumsMonth",jumpToMonthHandler);
        document.addEventListener("rjumpToAlbumsMonth", jumpToMonthHandler);

        const resetState = () =>{
            console.log("resetting the state when picker overlay closes");
            dispatch(albumsDataReset())
        }
    
        document.removeEventListener("resetTheState",resetState);
        document.addEventListener("resetTheState", resetState);
    },[])
    
    useEffect(() => {
        
        const sortOrder = photoOrg.history.historyState.so;
        const sortCriteria = photoOrg.history.historyState.sc;

        if(sortCriteria == "caption"){
            console.log("dispatching fetchCaptionSortAlbumList sorting=",sortOrder)
            dispatch(fetchCaptionSortAlbumList({
                sortOrder: sortOrder,
                minCollection: captionSortMinimumLimit
            }));
        }else{
            console.log("dispatching fetchOwnedAlbumList sorting=",sortOrder)
            dispatch(fetchOwnedAlbumList({
                sortCriteria: sortCriteria,
                sortOrder: sortOrder,
                timeZoneOffset: timeZoneOffset,
                clustersPerPage: clustersPerPage,
                pageNo: currentPage.current
            }));
        }
        
    },[dispatch, fetchOwnedAlbumList])

    useEffect(()=>{
        if(!selectionwedAlbumsRes || Object.keys(selectionwedAlbumsRes).length ==0 ){
            return;
        }
        if(photoOrg.saveAlbumDetails && photoOrg.saveAlbumDetails.saveAlbumId){
            let albumElement = document.getElementById(parseInt(photoOrg.saveAlbumDetails.saveAlbumId));
            if(albumElement){
                albumElement.scrollIntoView();
                photoOrg.saveAlbumDetails = {};
            }
        }else{
            try{//when dispatch is done or topScrolling is done when jumptomonth is enabled.
                let element = document.getElementById(photoOrg.photoLib.getKeyFromDate(currentPageLabel.current));
                //scroll to date selected by user using the currentPageLabel
                if(currentPageLabel.current && element){
                    currentPageLabel.current="";
                    //scroll is done here when element is prenset after xhr request
                    element.scrollIntoView();//{ behavior: 'smooth', block: 'start' }
                    setShowTopLoadingBar(true);
                }
            }catch(e){
                console.log("issue finding the element to scroll")
            }
        }
        if(Object.keys(selectionwedAlbumsRes.clusters).length <= clustersPerPage ){
            // onload if clusters are less than 5  then hide bottom loading bar
            if(Object.keys(selectionwedAlbumsRes.clusters).length < clustersPerPage) {
                setShowBottomLoadingBar(false)
            }
            console.log("passing the data to calender component",selectionwedAlbumsRes);
            //to show empty albums we are using this effect, to trigger bacbone side handling
            photoOrg.storage.setValueInStorage(photoOrg.constants.storagekeys.ACCOUNT_HAS_PHOTOS,true,{addAccountId:true, useLocalStorage:true});
            trigger("calender:pages",selectionwedAlbumsRes)
        }
        
    },[selectionwedAlbumsRes])

    useEffect(()=>{
        if(Object.keys(captionSortAlbumsRes).length ==0){
            return;
        }
        //will trigger only once the jump to month calendar
        console.log("passing the data to calender component caption sorting",captionSortAlbumsRes)
        setShowBottomLoadingBar(false)
        photoOrg.storage.setValueInStorage(photoOrg.constants.storagekeys.ACCOUNT_HAS_PHOTOS,true,{addAccountId:true, useLocalStorage:true});
        trigger("calender:pages",captionSortAlbumsRes);    
    },[captionSortAlbumsRes])
    
    

    useEffect(()=>{
        if(inView && Object.keys(selectionwedAlbumsRes).length > 0) {
            setShowBottomLoadingBar(true)
            loadNextPage();
        }
    },[inView])

    useEffect(()=>{
        if (selectionwedAlbumsRes && selectionwedAlbumsRes.clusters &&
            Object.keys(selectionwedAlbumsRes.clusters).length === 0 && photoOrg.history.historyState.st == photoOrg.constants.GOOGLE_VIEW
        ){
            photoOrg.Util.renderPhotosOrAlbumViewForInlineUser("GOOGLE")
        }
    },[selectionwedAlbumsRes])

    useEffect(()=>{
        if(tpInView && Object.keys(selectionwedAlbumsRes).length > 0) {
            loadPreviousPage();
        }
    },[tpInView])

    const loadPreviousPage = () => {
        console.log("load next page");
        if(currentPage.current < 0){
            currentPage.current = 0;
            setShowTopLoadingBar(false);
            return;
        }
        const pageData = selectionwedAlbumsRes.pages[currentPage.current];
        const url = isJumptoMonth.current ? pageData.currentUrl : pageData.prevUrl;
        try{
            let element = document.getElementById(photoOrg.photoLib.getKeyFromDate(pageData.clusters[0].date));
            //when used jumpto, chances are there that while scrolling top elements will be present then just decrement currentPage
            if(element){
                currentPage.current = currentPage.current - 1;
                return loadPreviousPage();
            }else{
                currentPageLabel.current = pageData.clusters[0].date;
            }
        }catch(e){
            console.log("issue finding element for loadPreviousPage")
        }

        photoOrg.tracker.add(photoOrg.tracker.constants.ALBUMS_VIEW_SCR_TOP,["page:"+currentPage.current]);
        dispatch(getPageClustersList({
            url: url,
            topScrolling: true,
            pageNo: currentPage.current
        }))
        currentPage.current = currentPage.current - 1;
    }

    const loadNextPage = () => {
        console.log("load next page");
        const pageData = selectionwedAlbumsRes.pages[currentPage.current];
        try{
            if((currentPage.current) === selectionwedAlbumsRes.pages.length) {
                console.log("all albums reached");
                currentPage.current = selectionwedAlbumsRes.pages.length - 1;
                setShowBottomLoadingBar(false);
                return;
            }
            let element = document.getElementById(photoOrg.photoLib.getKeyFromDate(pageData.clusters[0].date));
            //when used jumpto, chances are there that while scrolling bottom elements will be present then just increment currentPage
            if(element){
                currentPage.current = currentPage.current + 1;
                return loadNextPage();
            }
        }catch(e){
            console.log("issue finding element for loadNextPage")
        }
        let url = "";
        try{
            url = isJumptoMonth.current ? selectionwedAlbumsRes.pages[currentPage.current].currentUrl : selectionwedAlbumsRes.pages[currentPage.current - 1 ].nextUrl;
        }catch(err){
            console.log("all albums reached");
            setShowBottomLoadingBar(false);
            return;
        }
        photoOrg.tracker.add(photoOrg.tracker.constants.ALBUMS_VIEW_SCR_BOTTOM,["page:"+currentPage.current]);
        dispatch(getPageClustersList({
            url: url,
            bottomScrolling: true,
            pageNo: currentPage.current
        }))
        currentPage.current = currentPage.current + 1;
    }
    

    
    return (
        <>
            {showTopLoadingBar ?  
                (<div id="bottomLoadingBar" className='text-center' ref={tpref}>
                    <span className="icon-po-spin5 animate-spin"></span>
                    <div className="loading-dots mediumdots"><span role="status" className="dotid"></span></div>
                </div>) 
                : null 
            } 
            <ul className="albums-set" role="menuitem">
                {(Object.keys(selectionwedAlbumsRes).length > 0 && selectionwedAlbumsRes.pages && selectionwedAlbumsRes.pages.length > 0)?
                    <IterateAndGenerateAlbumDom rid="IterateAndGenerateAlbumDom" selectionOnwedAlbumsRes={selectionwedAlbumsRes} accessType={accessType} currentPageno ={currentPageno} />:
                    null
                } 
                {(Object.keys(captionSortAlbumsRes).length > 0 && captionSortAlbumsRes.jumpToModuleData)?
                    <IterateAndGenerateCaptionSortAlbumDom rid="IterateAndGenerateCaptionSortAlbumDom" captionSortAlbumsRes={captionSortAlbumsRes} accessType={accessType} />:
                    null
                }      
            </ul>
            {showBottomLoadingBar ?  
                (<div id="bottomLoadingBar" className='text-center' ref={ref}>
                    <span className="icon-po-spin5 animate-spin"></span>
                    <div className="loading-dots mediumdots"><span role="status" className="dotid"></span></div>
                </div>) 
                : null 
            } 
        </>
    )
}catch(e){
    photoOrg.clientLogger.error({description: "LIBRARY:OwnedAlbumsComponent:Exception", errorCode: "LIBRARY:MYALBUMS", err_desc: e.message, err_stack: e.stack});
}
}

OwnedAlbumsComponent.propTypes = {
    selectionwedAlbumsRes: PropTypes.object,
    captionSortAlbumsRes: PropTypes.object
}

export default OwnedAlbumsComponent;